<template>
  <div>
    <div v-if="$route.path.indexOf('_setting') === -1">
      <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
        <SpFilterFormItem prop="name" label="">
          <el-input v-model="formData.name" placeholder="仓库名称" />
        </SpFilterFormItem>
        <SpFilterFormItem prop="code" label="">
          <el-input v-model="formData.code" placeholder="仓库编码" />
        </SpFilterFormItem>
        <SpFilterFormItem prop="status" label="">
          <el-button type="primary" @click="addCategory">添加仓库</el-button>
        </SpFilterFormItem>
      </SpFilterForm>
      <SpFinder no-selection ref="finder" :setting="setting" row-actions-width="250" :row-actions-align="'left'"
        :fixed-row-action="true" :url="url" :hooks="{
          beforeSearch: beforeSearch,
          afterSearch: afterSearch
        }" :split-count="5">
      </SpFinder>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { createSetting } from '@shopex/finder'
import { useDialog } from '@shopex/finder'
import { afterSaleList, aftersalesSettingReturnDddressDetail, deleteAftersalesSettingReturnAddress } from './api'

const commonActions = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '保存', key: 'save', type: 'primary', size: 'default' }
]

export default {
  components: {
  },
  data() {
    return {
      url: afterSaleList,
      setting: createSetting({
        columns: [
          { name: '仓库名称', key: 'name' },
          { name: '发货仓编码', key: 'deliver_code' },
          { name: '退回仓库编码', key: 'code' },
          { name: '仓库售后地址', key: 'address' },
          { name: '联系方式', key: 'contact_phone' },
        ],
        actions: [
          {
            name: '编辑',
            key: 'edit',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: async (row) => {
                this.addCategory(row[0])
              }
            }
          },
          {
            name: '删除',
            key: 'delete',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: (row) => {
                this.handleDeleteDialog(row[0])
              }
            }
          },
        ]
      }),
      formData: {
        name: '',
        code: ''
      },
    }
  },
  methods: {
    // 添加/编辑仓库
    async addCategory(item) {
      let info = {}
      if (item.id) {
        const data = await aftersalesSettingReturnDddressDetail({ id: item.id })
        info = data.data.data
      }
      useDialog(null, {
        title: item.id ? '编辑仓库' : `添加仓库`,
        width: '50%',
        info: info,
        component: () => import('./comps/add-warehouse.vue'),
        actions: commonActions
      }).then((data) => {
        if (data) this.$refs.finder.refresh()
      })
    },
    onStatusChange(row, v) {
      putGiftingorderblessingGroup({ id: row.id, status: v }).then(res => {
      })
    },
    onSortChange(row, v) {
      putGiftingorderblessingGroup({ id: row.id, sort: v }).then(res => {
      })
    },
    beforeSearch(params) {
      const { name, code } = this.formData
      const pamars = {
        ...params,
        page_size: params.pageSize,
        name,
        code
      }
      return pamars
    },
    afterSearch(res) {
      const { data } = res.data
      return data
    },
    handleDeleteDialog(row) {
      deleteAftersalesSettingReturnAddress({ id: row.id }).then(res => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.$nextTick(() => {
          this.$refs.finder.refresh()
        })
      })
    },
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.formData = {
        name: '',
        code: ''
      }
      this.$refs.finder.refresh(true)
    },
  }
}
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.sp-finder-hd {
  padding-top: 10px !important;
}

.view-template-dialog {
  .sp-finder-hd {
    display: none;
  }

  .el-dialog__body {
    padding: 0 !important;

    .el-form {
      margin: 0 !important;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>
